import { render, staticRenderFns } from "./grade-record.vue?vue&type=template&id=37d1af8c&scoped=true"
import script from "./grade-record.vue?vue&type=script&lang=js"
export * from "./grade-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1af8c",
  null
  
)

export default component.exports